function createJsonOsRequestWithMovimentation(contract){
 

  let OsRequestContract =  {
    osNumber: contract.osNumber,
    statusOS: contract.statusOS,
    observation: contract.observation,
    source: contract.source,
    typeOS: contract.typeOS.value == null ? contract.typeOS : contract.typeOS.value,
    writeOffCode: contract.writeOffCode.value == null ? contract.writeOffCode : contract.writeOffCode.value,
    InstalledEquipmentSeriesNumber:  contract.equipamentNumberInstall,
    SerialNumberEquipmentUninstalled: contract.equipamentNumberDesinstall,
    action: contract.action.id_acao == null ? contract.action : contract.action.id_acao,
    state: contract.state.id_estado_equipamento == null ? contract.state : contract.state.id_estado_equipamento,
    NumberSmartcardInstalled: contract.cardNumberInstaled,
    NumberSmartcardUninstalled: contract.cardNumberUninstalled,
  }
  
  
  if (OsRequestContract.observation === null || OsRequestContract.observation === "") {
    delete OsRequestContract.observation;
  }
  
  return OsRequestContract;
  
}


export default createJsonOsRequestWithMovimentation;